import React, { useState, useEffect, useContext } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { AgendaManha } from "./Manha";
import { AgendaTarde } from "./Tarde";
import Legend from "../../components/Utils/Legend";
import moment from "moment";
import { GeralContext } from "../../contexts/Geral/GeralContext";
import RelAgendaVagas from "../../components/Utils/RelAgendaVagas";
import { PessoaContext } from "../../contexts/Pessoa/PessoaContext";

interface AgendaVagas {
  [id: string]: {
    [date: string]: {
      [dayOfWeek: string]: {
        manha: {
          [hora: string]: {
            [minuto: string]: { hr_inicio: string }[];
          };
        };
        tarde: {
          [hora: string]: {
            [minuto: string]: { hr_inicio: string }[];
          };
        };
      };
    };
  };
}

interface AtividadeItem {
  id_ativ: string;
  atividade: string;
  forma: string;
  n_pessoas: number;
  tmp_atividade: string;
}

const Agenda: React.FC = () => {
  const { agendaVagasActions  } = useContext(GeralContext);
  const { atividadeActions } = useContext(GeralContext);
  const [agendaVagas, setAgendaVagas] = React.useState<AgendaVagas>({});
  const [loading, setLoading] = useState<boolean>(true);
  const [ativSelected, setAtivSelected] = useState<string>("");
  const [ativData, setAtivData] = useState<AtividadeItem[]>([]);
  const [selectedAgenda, setSelectedAgenda] = useState<"manha" | "tarde">(() => {
    return (
      (localStorage.getItem("selectedAgenda") as "manha" | "tarde") || "manha"
    );
  });

  const [selectedDate, setSelectedDate] = useState(() => {
    const storedDate = localStorage.getItem("selectedDateManha");
    return storedDate ? new Date(storedDate) : new Date();
  });

  
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    const fetchAgendaVagasData = async () => {
      try {
        const agendaVagasData = await agendaVagasActions.fill(selectedDate.toISOString());
        setAgendaVagas(agendaVagasData);
      } catch (error) {
        console.error("Erro ao buscar dados da agenda vagas:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchAgendaVagasData();
  }, [agendaVagasActions, selectedDate, agendaVagas]);

  useEffect(() => {
    const fetchItemData = async () => {
      let ItemData: AtividadeItem[];
      try {
        ItemData = await atividadeActions.fill();
        setAtivData(ItemData);
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      }
    };
    fetchItemData();
  }, [atividadeActions]);

  // Atualiza o localStorage quando a data ou agenda mudam
  useEffect(() => {
    localStorage.setItem("selectedAgenda", selectedAgenda);
    updateLocalStorageDate(selectedDate);
  }, [selectedAgenda, selectedDate]);

  const updateLocalStorageDate = (date: Date) => {
    localStorage.setItem("selectedDateManha", date.toISOString());
    localStorage.setItem("selectedDateTarde", date.toISOString());
  };

  const handlePreviousDate = () => {
    const newDate = new Date(selectedDate);
    newDate.setDate(selectedDate.getDate() - 1);
    setSelectedDate(newDate);
    updateLocalStorageDate(newDate);
    setRefreshKey((prev) => prev + 1);
  };

  const handleNextDate = () => {
    const newDate = new Date(selectedDate);
    newDate.setDate(selectedDate.getDate() + 1);
    setSelectedDate(newDate);
    updateLocalStorageDate(newDate);
    setRefreshKey((prev) => prev + 1);
  };

const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  const selectedDateString = e.target.value; // Obtém o valor da data como string no formato YYYY-MM-DD
  const selectedDateParts = selectedDateString.split("-"); // Divide a string em partes (ano, mês, dia)
  
  const year = parseInt(selectedDateParts[0]);
  const month = parseInt(selectedDateParts[1]) - 1; // Mês base zero (0-11)
  const day = parseInt(selectedDateParts[2]);
  
  // Cria a nova data no fuso horário local
  const newDate = new Date(year, month, day);

  // Ajuste para UTC (se necessário, conforme sua lógica de fusos horários)
  // newDate.setMinutes(newDate.getMinutes() - newDate.getTimezoneOffset()); // Ajusta para UTC, se precisar

  setSelectedDate(newDate); // Atualiza o estado com a nova data
  updateLocalStorageDate(newDate); // Salva no localStorage
  setRefreshKey((prev) => prev + 1); // Força recriação, se necessário
};


  
  return (
    <div className="min-h-screen bg-gray-100 flex flex-col">
      {/* Área de seleção Manhã/Tarde */}
      <nav className="flex flex-col gap-3 p-3 bg-gray-200 lg:flex-row lg:flex-wrap lg:items-center lg:justify-center">
        <div className="flex flex-col gap-2 w-full lg:w-auto lg:flex-row lg:items-center lg:gap-4">
          <button
            onClick={() => setSelectedAgenda("manha")}
            className={`px-4 py-2 rounded ${
              selectedAgenda === "manha"
                ? "bg-blue-500 text-white"
                : "bg-gray-200 text-gray-700"
            }`}
          >
            Manhã
          </button>
          <button
            onClick={() => setSelectedAgenda("tarde")}
            className={`px-4 py-2 rounded ${
              selectedAgenda === "tarde"
                ? "bg-blue-500 text-white"
                : "bg-gray-200 text-gray-700"
            }`}
          >
            Tarde
          </button>
        </div>

        <div className="w-full lg:flex-1 lg:min-w-[360px] lg:max-w-[900px]">
          <Legend />
        </div>

        <div className="flex flex-col gap-3 w-full lg:w-auto lg:flex-row lg:items-center lg:gap-4">
          <RelAgendaVagas
            data={agendaVagas}
            loading={loading} // Passa a variável loading como prop
            turnoSelected={selectedAgenda}
            atividadeSelected={ativSelected}
          />
          <div className="flex flex-col items-center w-full lg:w-auto lg:items-start">
            <label
              htmlFor="situaterapeutation"
              className="text-sm font-semibold text-gray-700 mb-2 text-center lg:text-left"
            >
              Terapeuta
            </label>
            <select
              id="terapeuta"
              value={ativSelected}
              onChange={(e) => setAtivSelected(e.target.value)}
              className="w-full max-w-xs lg:w-56 px-4 py-2 text-sm text-gray-700 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring focus:ring-blue-500"
            >
              <option value="">Selecione a terapia</option>
              {ativData
                .sort((a, b) => a.atividade.localeCompare(b.atividade))
                .map((agenda) => (
                  <option key={agenda.atividade} value={agenda.atividade}>
                    {agenda.atividade}
                  </option>
                ))}
            </select>
          </div>
        </div>
      </nav>

      {/* Controle de data */}
      <div className="flex flex-col items-center mx-4 mb-4 sm:mb-6">
        <div className="text-center mt-3 mb-4 sm:mt-0">
          <h4 className="font-bold">
            {moment(selectedDate).format("dddd, D [de] MMMM [de] YYYY")}
          </h4>
        </div>
        <div className="flex flex-col items-center gap-4 sm:flex-row sm:items-center sm:gap-2">
          <button
            onClick={handlePreviousDate}
            className="px-4 py-2 bg-blue-500 text-white rounded-lg sm:rounded-l-lg hover:bg-blue-600"
          >
            Anterior
          </button>
          <input
            type="date"
            value={moment(selectedDate).format("YYYY-MM-DD")}
            onChange={handleDateChange}
            className="px-4 py-2 text-center border rounded-md"
          />
          
          <button
            onClick={handleNextDate}
            className="px-4 py-2 bg-blue-500 text-white rounded-lg sm:rounded-r-lg hover:bg-blue-600"
          >
            Próximo
          </button>
        </div>
      </div>
   {/* Área da agenda */}
      <div key={refreshKey} className="flex-1 bg-white p-3 rounded shadow-md">
        {selectedAgenda === "manha" && <AgendaManha />}
        {selectedAgenda === "tarde" && <AgendaTarde />}
      </div>
    </div>

  );
};

export default Agenda;
